import React from 'react';

const CrownIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={32}
      height={32}
      viewBox='0 0 32 32'
      fill='none'
      {...props}
    >
      <path
        d='M3.73383 6.93328L9.33383 10.6666L14.9152 2.85328C15.0385 2.68044 15.2013 2.53955 15.3901 2.44235C15.5789 2.34515 15.7882 2.29443 16.0005 2.29443C16.2128 2.29443 16.4221 2.34515 16.6109 2.44235C16.7997 2.53955 16.9625 2.68044 17.0858 2.85328L22.6672 10.6666L28.2672 6.93328C28.4791 6.79227 28.727 6.71489 28.9815 6.71026C29.236 6.70564 29.4865 6.77396 29.7035 6.90717C29.9204 7.04038 30.0946 7.23291 30.2056 7.46199C30.3166 7.69108 30.3597 7.94715 30.3298 8.19995L28.1392 26.8226C28.101 27.1469 27.945 27.446 27.701 27.663C27.4569 27.88 27.1417 27.9999 26.8152 27.9999H5.18583C4.85925 27.9999 4.54405 27.88 4.3 27.663C4.05596 27.446 3.90004 27.1469 3.86183 26.8226L1.67116 8.19861C1.64156 7.94592 1.68488 7.69004 1.79599 7.46117C1.90711 7.2323 2.08138 7.03999 2.29825 6.90696C2.51511 6.77393 2.76551 6.70571 3.01988 6.71038C3.27426 6.71504 3.52199 6.79239 3.73383 6.93328ZM16.0005 19.9999C16.7077 19.9999 17.386 19.719 17.8861 19.2189C18.3862 18.7188 18.6672 18.0405 18.6672 17.3333C18.6672 16.626 18.3862 15.9478 17.8861 15.4477C17.386 14.9476 16.7077 14.6666 16.0005 14.6666C15.2933 14.6666 14.615 14.9476 14.1149 15.4477C13.6148 15.9478 13.3338 16.626 13.3338 17.3333C13.3338 18.0405 13.6148 18.7188 14.1149 19.2189C14.615 19.719 15.2933 19.9999 16.0005 19.9999Z'
        fill='url(#paint0_linear_9139_56530)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_9139_56530'
          x1='9.77932'
          y1='2.29443'
          x2='22.2218'
          y2='27.9999'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#593A1A' />
          <stop offset={1} stopColor='#D3A984' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CrownIcon;
